<template>
  <div class="SCTransaction">
    <section-header heading="2" ja="「特定商取引に関する法律」に基づく表示"/>
    <div class="terms-text">
      <p>1.販売価格（役務の対価）</p>
      <ol>
        <li>アプリ内の購入画面をご覧ください。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>2.対価の支払時期・方法</p>
      <ol>
        <li>お客様が選択した支払方法に関する、プラットフォーム事業者、クレジットカード会社等の規約に基づきます。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>3.商品の引渡時期（役務の提供時期）</p>
      <ol>
        <li>購入後直ちに。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>4.返金の特約</p>
      <ol>
        <li>本サービスの特性上、法令において特に義務付けられる場合を除き、返金は致しません。一旦行っていただいた購入の撤回・解除はできませんので、予めご了承ください。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>5.事業者の名称・住所・代表者名・電話番号・メールアドレス、苦情・相談に応じる連絡先</p>
      <ol>
        <li>名称：株式会社セガ</li>
        <li>住所：〒141-0033 東京都品川区西品川一丁目1番1号住友不動産大崎ガーデンタワー</li>
        <li>代表者：杉野 行雄</li>
        <li>電話：0570-000-353</li>
        <li>メールアドレス：segaonlinesupport@sega.com</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>6.販売価格（役務の対価）以外にお客様にご負担いただく金銭</p>
      <ol>
        <li>本サービスに関するサイトの閲覧、コンテンツのダウンロード及びアプリケーション動作時における通信に必要な通信料。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>7.サービス内容に瑕疵がある場合の責任</p>
      <ol>
        <li>弊社は、本サービスについて、その完全性、正確性、有用性等に関するいかなる保証もいたしません。また、弊社が責任を負う場合でも、責任の範囲は、お客様に生じた現実且つ直接の損害の範囲に限り、弊社の予見の有無にかかわらず、特別の事情から生じた損害、逸失利益、間接損害、その他の損害について弊社は一切の責任を負わないものとします。 但し弊社の故意又は重大な過失による場合にはこの限りではありません。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>8.商品の販売先</p>
      <ol>
        <li>日本国内限定 の販売とさせていただいております。</li>
      </ol>
    </div>
    <div class="terms-text">
      <p>9.本サービスを利用可能な動作環境</p>
      <ol>
        <li>アプリ「プリクラON」</li>
        <li>対応端末：アプリの各配信ストアをご確認ください</li>
      </ol>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"

export default {
  name: "SCTransaction",
  components: {
    SectionHeader
  },
  methods: {
    oniOS() {
      window.open(process.env.VUE_APP_PRIVACY_POLICY_URL)
    },
    onAndroid() {
      window.open(process.env.VUE_APP_PRIVACY_PROTECTION_URL)
    },
  }
}
</script>

<style scoped>
.terms-text {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.textLink { color: #DA2240; }
</style>
